import {useState} from "react";
import className from "classnames/bind";
import {Button, FontAwesomeIcon, Loading} from "~/components";
import {useGetHtmlSitemapQuery} from "~/reduxs/api/technicalApiSlice";
import style from "../style/Technical.module.scss";

const cn = className.bind(style);

/**
 * HTML sitemap (#2): sinh đoạn HTML sơ đồ website từ lần crawl mới nhất (backend nhóm
 * trang theo phân đoạn path, chỉ trang 2xx + indexable). Người dùng copy/tải về nhúng
 * vào trang "Sơ đồ website" của họ — tốt cho cả người dùng lẫn crawler. Fetch lazy khi
 * tab được mở (thuần DB, nhanh).
 */
function TechHtmlSitemap({projectId}) {

	const {data, isLoading, isFetching} = useGetHtmlSitemapQuery(projectId);
	const [copied, setCopied] = useState(false);

	if (isLoading || isFetching) return <Loading />;

	if (!data?.crawl || !data?.content) {
		return (
			<div className={cn('tab')}>
				<div className={cn('empty')}>
					<FontAwesomeIcon icon="fa-light fa-sitemap" />
					<p>Chưa có dữ liệu crawl để sinh HTML sitemap. Hãy chạy Site Crawler trước.</p>
				</div>
			</div>
		);
	}

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(data.content);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch (e) { /* trình duyệt chặn clipboard — người dùng bôi đen copy tay */ }
	};

	const handleDownload = () => {
		const blob = new Blob([data.content], {type: 'text/html;charset=utf-8'});
		const url = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = 'html-sitemap.html';
		a.click();
		URL.revokeObjectURL(url);
	};

	return (
		<div className={cn('tab')}>
			<p className={cn('muted')}>
				<strong>HTML sitemap</strong> là trang "Sơ đồ website" dành cho NGƯỜI DÙNG (khác sitemap.xml dành cho
				bot) — giúp khách tìm nhanh nội dung và bổ sung liên kết nội bộ tới mọi trang quan trọng. Đoạn HTML
				dưới đây sinh tự động từ {data.pages_used} trang (2xx, cho phép index) của lần crawl{' '}
				<strong>#{data.crawl.id}</strong> — nhúng vào một trang như <code>/so-do-website</code> rồi link từ footer.
			</p>

			<div style={{display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap'}}>
				<Button primary onClick={handleDownload} leftIcon={<FontAwesomeIcon icon="fa-light fa-download" />}>
					Tải HTML
				</Button>
				<Button onClick={handleCopy} leftIcon={<FontAwesomeIcon icon={copied ? 'fa-light fa-check' : 'fa-light fa-copy'} />}>
					{copied ? 'Đã sao chép' : 'Sao chép'}
				</Button>
			</div>

			<pre style={{background: '#f6f8fa', border: '1px solid #e5e7eb', borderRadius: 8, padding: 16, maxHeight: 480, overflow: 'auto', fontSize: 13, lineHeight: 1.6, whiteSpace: 'pre-wrap'}}>
				{data.content}
			</pre>
		</div>
	);
}

export default TechHtmlSitemap;
